import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { SeedRequest, SeedRequestService } from "../services/seed-request.service";

@Injectable()
export class SeedRequestsResolver implements Resolve<SeedRequest[]> {
  constructor(private seedRequestService: SeedRequestService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<SeedRequest[]> {
    const id: number = route.params['id'];
    return this.seedRequestService.getAll(id);
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/resolvers/seed-requests-resolver.ts